import React from 'react';
import { fetchAppVersion, fetchChangelog, AppVersionInfo, ChangelogResponse } from '../services/versionService';

const STORAGE_KEY = 'app:version:lastSeen';

export interface UseAppUpdateNotifierResult {
  open: boolean;
  versionInfo: AppVersionInfo | null;
  changelog: ChangelogResponse | null;
  handleClose: () => void;
}

export default function useAppUpdateNotifier(): UseAppUpdateNotifierResult {
  const [open, setOpen] = React.useState(false);
  const [versionInfo, setVersionInfo] = React.useState<AppVersionInfo | null>(null);
  const [changelog, setChangelog] = React.useState<ChangelogResponse | null>(null);

  React.useEffect(() => {
    let mounted = true;
    const init = async () => {
      const [ver, log] = await Promise.all([fetchAppVersion(), fetchChangelog()]);
      if (!mounted) return;
      setVersionInfo(ver);
      setChangelog(log);

      const remoteVersion = ver?.version || log?.version;
      if (!remoteVersion) return;

      let lastSeen: string | null = null;
      try { lastSeen = localStorage.getItem(STORAGE_KEY); } catch {}

      if (lastSeen !== remoteVersion) {
        setOpen(true);
      }
    };
    init();
    return () => { mounted = false; };
  }, []);

  const handleClose = React.useCallback(() => {
    const remoteVersion = versionInfo?.version || changelog?.version;
    if (remoteVersion) {
      try { localStorage.setItem(STORAGE_KEY, remoteVersion); } catch {}
    }
    setOpen(false);
  }, [versionInfo, changelog]);

  return { open, versionInfo, changelog, handleClose };
}


